import React, {createContext, useContext, useState} from 'react'

type ModalMode = 'deposit' | 'withdraw'

type DepositWithdrawModalContextType = {
  modalOpen: boolean
  modalMode: ModalMode
  initialAmountUsd?: number
  openModal: (mode: ModalMode, amountUsd?: number) => void
  closeModal: () => void
}

const DepositWithdrawModalContext = createContext<DepositWithdrawModalContextType | null>(null)

export const DepositWithdrawModalProvider = ({children}: {children: React.ReactNode}) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [modalMode, setModalMode] = useState<ModalMode>('deposit')
  const [initialAmountUsd, setInitialAmountUsd] = useState<number | undefined>()

  const openModal = (mode: ModalMode, amountUsd?: number) => {
    setModalMode(mode)
    setInitialAmountUsd(amountUsd)
    setModalOpen(true)
  }

  const closeModal = () => {
    setModalOpen(false)
    setInitialAmountUsd(undefined)
  }

  return (
      <DepositWithdrawModalContext.Provider value={{modalOpen, modalMode, initialAmountUsd, openModal, closeModal}} >
        {children}
      </DepositWithdrawModalContext.Provider>
  )
}

export const useDepositWithdrawModal = () => {
  const context = useContext(DepositWithdrawModalContext)
  if (!context) {
    throw new Error('useDepositWithdrawModal must be used within DepositWithdrawModalProvider')
  }
  return context
}